import { getTransactionList } from './states';

export const services = {
  getTransactionList,
};
